const r = {
  name: "paragraph",
  components: ["transform", "paragraph"]
}, a = {
  name: "word",
  components: ["transform", "word"]
};
export {
  r as paragraphRecipe,
  a as wordRecipe
};
//# sourceMappingURL=recipes.js.map
